import { GenericErrorPage } from "./GenericErrorPage";

export { GenericErrorPage };
